<template>
	<div class="page-list-cont">
		<div class="page-list-form">
			<slot name="form"></slot>
		</div>
		<div class="page-list-table">
			<slot name="show"></slot>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {};
	},
	mounted() {},
	methods: {},
};
</script>

<style lang="scss" scoped type="text/css">
.page-list-cont {
	height: 100%;
	background-color: #fff;
	box-sizing: border-box;
	padding: 10px;

	.page-list-form::after {
		content: "";
		display: block;
		clear: both;
	}
}
</style>
